import script from "./UpvoteAction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UpvoteAction.vue?vue&type=script&lang=js"
export * from "./UpvoteAction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UpvoteAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/UpvoteAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "440cb1fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('440cb1fc', __exports__)) {
    api.reload('440cb1fc', __exports__)
  }
  
}


export default __exports__